import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { motion } from "framer-motion";
import { X } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { videoEmbed, videoThumb } from "./Sections";

export const VideoModal = ({ video, onClose }) => {
  const { t, L } = useLang();
  const e = videoEmbed(video?.video_url);
  useEffect(() => {
    window.__lenis?.stop();
    const k = (ev) => { if (ev.key === "Escape") onClose(); };
    window.addEventListener("keydown", k);
    return () => { window.removeEventListener("keydown", k); window.__lenis?.start(); };
  }, [onClose]);
  return createPortal(
    <motion.div data-testid="video-modal" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="fixed inset-0 z-[100] flex items-center justify-center bg-black/95 p-4">
      <button onClick={onClose} data-testid="video-modal-close" aria-label={t("close")} className="absolute right-5 top-5 flex h-11 w-11 items-center justify-center border border-white/20 text-white hover:border-white"><X /></button>
      <div className="w-full max-w-6xl">
        <div className="relative aspect-video w-full bg-black">
          {e ? <iframe title={L(video, "title")} src={e.embed} className="absolute inset-0 h-full w-full" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen data-testid="video-modal-iframe" />
            : (
              <div className="absolute inset-0 flex items-center justify-center">
                {videoThumb(video) && <img src={videoThumb(video)} alt="" className="absolute inset-0 h-full w-full object-cover opacity-30" />}
                <p className="kicker relative !text-white" data-testid="video-modal-not-linked">{t("notLinked")}</p>
              </div>
            )}
        </div>
        <div className="mt-5 flex flex-col gap-2 md:flex-row md:items-baseline md:justify-between">
          <h3 className="font-display text-2xl font-bold text-white">{L(video, "title")}</h3>
          <p className="max-w-xl text-sm text-white/65">{L(video, "description")}</p>
        </div>
      </div>
    </motion.div>,
    document.body
  );
};

export const useVideoModal = () => {
  const [v, setV] = useState(null);
  return [v, setV];
};
